import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { useTranslation } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

interface IAnimatedBackgroundPanelPresenterStore {
  isPanelShown: boolean;
  isVideoMuted: boolean;
  ongoingCall: Call;
  hidePanel(): void;
}

export const useAnimatedBackgroundPanelPresenter = (): IAnimatedBackgroundPanelPresenterStore => {
  const { t } = useTranslation();
  const context = useCallContext();

  const presenter = useLocalObservable<IAnimatedBackgroundPanelPresenterStore>(() => ({
    get ongoingCall(): Call {
      return context.call;
    },

    get isPanelShown(): boolean {
      return presenter.ongoingCall.viewState.backgroundPanelShown;
    },
    get isVideoMuted(): boolean {
      return presenter.ongoingCall.meStore.isVideoMuted;
    },

    hidePanel(): void {
      presenter.ongoingCall.viewState.hideBackgroundPanel();
    },
  }));

  useEffect(() => {
    if (presenter.isPanelShown && presenter.isVideoMuted) {
      presenter.hidePanel();
      popupsTasks.showAlert(t('call_background_camera_is_off_message'));
    }
  }, [presenter.isPanelShown, presenter.isVideoMuted]);

  return presenter;
};
